import {defineStore} from 'pinia'
import api from '@/services/api'
import {useUserStore} from '@/stores/user'

export const useOdpCourseDatesMenusStore = defineStore('odpCourseDatesMenus', {
    state: () => ({
        courses: undefined,
        schools: undefined,
    }),
    
    getters: {
        getCourses: (state) => (isArchived) => {
            if (!state.courses) return [{value: '', text: 'Select a course…'}]
            
            return [
                {value: '', text: 'Select a course…'},
                ...state.courses
                    .filter((o) => (isArchived ? o.isArchived : !o.isArchived))
                    .map((o) => ({value: o.id, text: o.title})),
            ]
        },
        
        getSchools: (state) => (isArchived) => {
            if (!state.schools) return [{value: '', text: 'Select a school…'}]
            
            return [
                {value: '', text: 'Select a school…'},
                ...state.schools
                    .filter((o) => (isArchived ? o.isArchived : !o.isArchived))
                    .map((o) => ({value: o.id, text: o.name})),
            ]
        },
    },
    
    actions: {
        async fetchCourses() {
            const userStore = useUserStore()
            
            if (this.courses === undefined) {
                const {data: {items}} = await api.get('api/component/odp_courses', {
                    params: {
                        fields: ['id', 'title', 'isArchived'],
                        sort: 'title',
                        ...(userStore.user?.franchiseId && {
                            franchiseId: userStore.user.franchiseId,
                        }),
                    },
                })
                
                this.courses = items
            }
        },
        
        async fetchSchools() {
            const userStore = useUserStore()
            
            if (this.schools === undefined) {
                const {data: {values: schoolIds}} = await api.get('api/component/odp_course_dates/schoolId', {
                    params: {schoolId: {gt: 0}},
                })
                
                const {data: {items}} = await api.get('api/component/odp_schools', {
                    params: {
                        fields: ['id', 'name', 'isArchived'],
                        id: schoolIds,
                        sort: 'name',
                        ...(userStore.user?.franchiseId && {
                            franchiseId: userStore.user.franchiseId,
                        }),
                    },
                })
                
                this.schools = items
            }
        },
    },
})